// eslint-disable-next-line @typescript-eslint/no-require-imports
const CustomCategoryImage = require('./custom-category.png');

export const assets = {
  CustomCategoryImage,
};
